import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import ChevronSVG from '../../../../../../images/svg/icons8-expand-arrow';
import Text from '../../../../../global/text/text';
import { Popover } from '../../../../../global/popover/popover';
import { ConnectionType } from '../../../../../../api/connections.dao';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { IDetailsItemField } from '../../connection-template-form.viewmodel';
import { TextWithCopyBtn } from '../../../../../_events/_manage-event/shared/connections-list/_connection-details-popover';
import { CONFIGURE_PASSPORT_DISPLAY_TEXT, EDIT_TEXT, MORE_BUTTON_TEXT, REMOVE_TEXT } from '../../../../../../constants/common-labels.constants';
import OptionsButton from '../../../../../global/options-button/options-button';

interface IProps {
    intl: IntlShape;
    fields: IDetailsItemField[];
    label: string;
    type: ConnectionType;
    removeConnection: () => void;
    editConnection: () => void;
    configurePassportDisplay: () => void;
};

export const ConnectionTemplatesDetailsItem = injectIntl(observer((props: IProps): JSX.Element => {
    const { intl, fields, label, removeConnection, editConnection, configurePassportDisplay } = props;
    const [isPopoverOpen, handleOpenPopover] = useState<boolean>(false);
    const listItemRef = useRef(null);
    const popupWidth: number = 180;

    const optionsButton = [
        {
            label: intl.formatMessage(EDIT_TEXT),
            action: editConnection,
        },
        {
            label: intl.formatMessage(CONFIGURE_PASSPORT_DISPLAY_TEXT),
            action: configurePassportDisplay,
        },
        {
            label: intl.formatMessage(REMOVE_TEXT),
            action: removeConnection,
            danger: true
        },
    ];

    return (
        <>
            <div
                ref={listItemRef}
                className={classNames('connection-list__item', {
                    'connection-list__item--active': isPopoverOpen
                })}
                onClick={handleOpenPopover.bind(null, !isPopoverOpen)}
            >
                <Text className='overflow-ellipsis' message={label} />
                <div className='attendee-button__chevron'>
                    <ChevronSVG />
                </div>
            </div>
            {isPopoverOpen &&
                <div className='connection-item-popover'>
                    <Popover
                        isOpen={isPopoverOpen}
                        buttonRef={listItemRef}
                        onClickOutside={handleOpenPopover.bind(null, false)}
                        customWidth={popupWidth}
                        padding={0}
                        align='start'
                    >
                        <div className='w-100' onClick={e => e.stopPropagation()}>
                            <div className='connection-list__popover'>
                                {fields.map(x => {
                                    if (!x.value) return;

                                    return (
                                        <div className={classNames('connection-list__field', { 'overflow-ellipsis': !x.showFullValue })} key={x.label}>{x.label}: <br />
                                            {x.withCopyBtn
                                                ? <TextWithCopyBtn message={x.value} />
                                                : <Text tag='b' message={x.value} withEllipsis={!x.showFullValue} />
                                            }
                                        </div>
                                    );
                                })}

                                <OptionsButton
                                    className='small-button'
                                    label={<FormattedMessage {...MORE_BUTTON_TEXT} />}
                                    options={optionsButton}
                                    position='top'
                                    align='start'
                                />
                            </div>

                        </div>
                    </Popover>
                </div>
            }
        </>
    );
}));
